module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/WhoNooklynFor/renters-12b1b3ff2ec862dc6190b3aac9f96570.jpg";